import React from 'react';
import './style.css'
import MessageBox from '../components/Common/Message/MessageBox';
import { Card } from 'react-bootstrap';
import { __MessageTypes } from '../common/Dictionaries';
import { useTranslation } from 'react-i18next';

const NotDataAccess = (props) => {
    const { t } = useTranslation();

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header>
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-boxname-accesserror')}</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                    <MessageBox  
                        inputParam_Message={ 'No tiene permisos para acceder al recurso. Si debe tener permisos, favor contacte al administrador.' }
                        inputParam_Display={ true }
                        inputParam_MessageType={ __MessageTypes.ERROR }
                        inputParam_SetterMessage={ null }
                    />
                </Card.Footer>
            </Card>
        </div>
    )
}
export default NotDataAccess